import { Reveal, SectionHead, MaskLine, AcidWord } from "./Reveal";

export const WhatIs = () => (
  <section id="what" data-testid="what-is-parallel-section" className="bg-obsidian py-28 sm:py-40">
    <div className="max-w-[1600px] mx-auto px-5 sm:px-10">
      <SectionHead num="03" eyebrow="The Studio" title={<>What is PARA<AcidWord>{"//"}</AcidWord>EL?</>} />

      <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-16">
        <Reveal className="lg:col-span-7">
          <p className="font-head text-2xl sm:text-4xl font-semibold uppercase tracking-tight leading-[1.05] text-cream">
            <MaskLine delay={0.1}>A training ground that runs</MaskLine>
            <MaskLine delay={0.2}>like a working agency —</MaskLine>
            <MaskLine delay={0.3}><span className="text-acid">not a classroom.</span></MaskLine>
          </p>
          <p className="mt-8 text-base sm:text-lg text-smoke leading-relaxed max-w-xl">
            PARA//EL bridges raw creative instinct with real agency production pipelines. You learn
            direction, camera craft, AI synthesis and client delivery by shipping actual commercial
            work — briefs, deadlines, revisions and all — under working creative directors from Athrv Co.
          </p>
          <div className="mt-10 grid grid-cols-3 gap-px bg-line border border-line">
            {["Film", "Brand", "AI"].map((t) => (
              <div key={t} className="bg-obsidian px-4 py-6 text-center">
                <span className="font-mono text-xs uppercase tracking-[0.3em] text-cream">{t}</span>
              </div>
            ))}
          </div>
        </Reveal>

        <Reveal delay={0.15} className="lg:col-span-5 group">
          <div className="relative overflow-hidden border border-line">
            <img
              src="https://images.unsplash.com/photo-1632187981988-40f3cbaeef5e?crop=entropy&cs=srgb&fm=jpg&q=85"
              alt="Film set with production lighting"
              className="img-cine w-full h-[420px] sm:h-[540px] object-cover"
            />
            <div className="absolute bottom-0 left-0 right-0 flex justify-between items-center px-5 py-4 bg-obsidian/80 backdrop-blur-sm border-t border-line">
              <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-smoke">Studio Floor — Athrv Co.</span>
              <span className="font-mono text-[10px] uppercase tracking-[0.25em] text-acid">EST. 2026</span>
            </div>
          </div>
        </Reveal>
      </div>
    </div>
  </section>
);
